module.exports = __webpack_public_path__ + "img/inseadxr-logo.f49d904c.webp";